import { HStack, Divider } from '@cdl/heartbeat-react';
import { PatientInfoCard } from './PatientInfoCard';
import { useSelector } from 'react-redux';
import { ageSelector, sexSelector } from '../selectors/ecg.selectors';

export const PatientInfo: React.FC = () => {
  const age = useSelector(ageSelector);
  const sex = useSelector(sexSelector);

  if (age == null && sex == null) {
    return null;
  }

  return (
    <HStack
      bgColor='neutral.0'
      spacing='s'
      p='s'
      borderRadius='4px'
      divider={<Divider orientation='vertical' />}
      shadow={400}
    >
      {age && <PatientInfoCard label='Age' value={age} />}
      {sex && <PatientInfoCard label='Sex' value={sex} />}
    </HStack>
  );
};
